
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';

// Real social media content from your original site
const portfolioContent = [
  {
    id: 1,
    title: "Skyline In The Marina",
    client: "Social Media Content",
    platform: "Instagram",
    type: "Feed Post",
    videoId: "6qTWzvroJ_8",
    thumbnail: "https://img.youtube.com/vi/6qTWzvroJ_8/maxresdefault.jpg",
    engagement: "High engagement",
    description: "Captivating Skyline showcase content for social media platforms",
    format: "full"
  },
  {
    id: 2,
    title: "NQ Springs Social Media Campaign",
    client: "NQ Springs 4x4",
    platform: "Instagram",
    type: "Feed Post",
    videoId: "tKbmjSjZs_8",
    thumbnail: "https://img.youtube.com/vi/tKbmjSjZs_8/maxresdefault.jpg",
    engagement: "High engagement",
    description: "Professional social media campaign showcasing NQ Springs 4x4 services",
    format: "full"
  },
  {
    id: 3,
    title: "1Million Strong Gym Opening",
    client: "1Million Strong Gym",
    platform: "TikTok",
    type: "Reel",
    videoId: "JczO1J2a87I",
    thumbnail: "https://img.youtube.com/vi/JczO1J2a87I/maxresdefault.jpg",
    engagement: "Viral potential",
    description: "Grand opening coverage for 1Million Strong Gym optimized for TikTok and Instagram Reels",
    format: "short"
  },
  {
    id: 4,
    title: "Agent End Of Year Review",
    client: "Real Estate Agent",
    platform: "Instagram",
    type: "Reel",
    videoId: "A5nwtFf4b6Q",
    thumbnail: "https://img.youtube.com/vi/A5nwtFf4b6Q/maxresdefault.jpg",
    engagement: "Professional reach",
    description: "Real estate agent year-end review content for professional social platforms",
    format: "short"
  },
  {
    id: 5,
    title: "NQ Springs Vehicle Upgrade",
    client: "NQ Springs 4x4",
    platform: "Instagram",
    type: "Story",
    videoId: "1NAR2u8x6Lg",
    thumbnail: "https://img.youtube.com/vi/1NAR2u8x6Lg/maxresdefault.jpg",
    engagement: "Brand awareness",
    description: "NQ Springs 4x4 vehicle upgrade showcase for social media",
    format: "short"
  },
  {
    id: 6,
    title: "1Million Strong Gym Upgrade",
    client: "1Million Strong Gym",
    platform: "TikTok",
    type: "Short Video",
    videoId: "Ge04JrCkH4k",
    thumbnail: "https://img.youtube.com/vi/Ge04JrCkH4k/maxresdefault.jpg",
    engagement: "Story views",
    description: "Gym facility upgrade showcase perfect for Instagram Stories and TikTok",
    format: "short"
  }
];

const services = [
  {
    id: 1,
    title: "Content Creation",
    description: "High-quality posts and stories for all platforms",
    features: [
      "Platform-specific content",
      "Professional editing",
      "Trending audio integration",
      "Multiple format delivery",
      "Content calendar planning",
      "Hashtag research"
    ]
  },
  {
    id: 2,
    title: "Reels & Short Videos",
    description: "Viral-ready content for Instagram and TikTok",
    features: [
      "Vertical video optimization",
      "Trending effects and filters",
      "Quick turnaround",
      "Platform best practices",
      "Engagement optimization",
      "Story templates"
    ]
  },
  {
    id: 3,
    title: "Brand Campaigns",
    description: "Comprehensive social media campaigns",
    features: [
      "Multi-platform strategy",
      "Brand consistency",
      "Campaign planning",
      "Performance tracking",
      "Content series creation",
      "Audience targeting"
    ]
  },
  {
    id: 4,
    title: "Live Content",
    description: "Real-time content and event coverage",
    features: [
      "Live streaming setup",
      "Event documentation",
      "Real-time editing",
      "Multi-camera coverage",
      "Interactive content",
      "Behind-the-scenes footage"
    ]
  }
];

export default function SocialMedia() {
  const [selectedContent, setSelectedContent] = useState(null);

  const handleContentClick = (content) => {
    setSelectedContent(content);
  };

  const closeContentModal = () => {
    setSelectedContent(null);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-rose-50">
      {/* Navigation */}
      <Navbar variant="light" position="absolute" />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Video Background - Desktop */}
        <div className="absolute inset-0 w-full h-full hidden md:block">
          <iframe
            src="https://www.youtube.com/embed/YIPkAbm9RVQ?autoplay=1&mute=1&loop=1&playlist=YIPkAbm9RVQ&controls=0&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&playsinline=1&vq=hd1440"
            title="Social Media Video Background"
            className="w-full h-full object-cover"
            style={{ minWidth: '100%', minHeight: '100%', transform: 'scale(1.1)' }}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
          {/* Video Overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
        </div>

        {/* Video Background - Mobile (Shorts) */}
        <div className="absolute inset-0 w-full h-full md:hidden">
          <iframe
            src="https://www.youtube.com/embed/6fjQ9yKreGA?autoplay=1&mute=1&loop=1&playlist=6fjQ9yKreGA&controls=0&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&playsinline=1"
            title="Social Media Mobile Video Background"
            className="w-full h-full object-cover"
            style={{ minWidth: '100%', minHeight: '100%', transform: 'scale(1.1)' }}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
          {/* Video Overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
        </div>

        <div className="relative z-10 text-center px-6 max-w-6xl mx-auto text-white">
          <div className="mb-8">
            <span className="inline-block px-8 py-3 bg-white/20 backdrop-blur-sm rounded-full text-white font-semibold text-sm tracking-wider border border-white/30">
              SOCIAL MEDIA CONTENT
            </span>
          </div>
          <h1 className="text-6xl md:text-8xl font-black mb-8 tracking-tight leading-none text-white drop-shadow-2xl">
            GO VIRAL
            <span className="block bg-gradient-to-r from-purple-400 via-pink-400 to-rose-400 bg-clip-text text-transparent">
              WITH STYLE
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-white/90 max-w-4xl mx-auto leading-relaxed mb-12 font-light drop-shadow-lg">
            Engaging social media content that captures attention, builds communities, and drives real results across all platforms
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <button 
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-10 py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold text-lg rounded-full hover:from-purple-700 hover:to-pink-700 transition-all duration-300 transform hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap backdrop-blur-sm"
            >
              VIEW SERVICES
            </button>
            <button 
              onClick={() => document.getElementById('portfolio')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-10 py-4 bg-white/20 backdrop-blur-sm border-2 border-white/50 text-white font-bold text-lg rounded-full hover:bg-white/30 hover:border-white/70 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-2xl"
            >
              VIEW PORTFOLIO
            </button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
          <div className="animate-bounce">
            <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
              <div className="w-1 h-3 bg-white/70 rounded-full mt-2 animate-pulse"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      <section id="portfolio" className="py-32 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-20">
            <span className="inline-block px-8 py-3 bg-purple-100 rounded-full text-purple-700 font-semibold text-sm tracking-wider border border-purple-200 mb-6">
              OUR CONTENT
            </span>
            <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-8 tracking-tight">
              Social Media Portfolio
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Discover our creative social media content that drives engagement and builds brand communities
            </p>
          </div>

          {/* Custom Grid Layout for Mixed Video Types */}
          <div className="max-w-7xl mx-auto">
            <div className="space-y-8">
              {/* First Row: 2 Horizontal Videos */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {portfolioContent.filter(content => content.format === 'full').slice(0, 2).map((content) => (
                  <div key={content.id} className="group cursor-pointer">
                    <div 
                      className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                      onClick={() => handleContentClick(content)}
                      style={{ aspectRatio: '16/9' }}
                    >
                      <img 
                        src={content.thumbnail}
                        alt={content.title}
                        className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                          <h3 className="text-xl font-bold mb-2 leading-tight">{content.title}</h3>
                          <p className="text-purple-200 flex items-center text-base">
                            <i className="ri-building-line mr-2"></i>
                            {content.client}
                          </p>
                          <p className="text-pink-200 text-sm">{content.engagement}</p>
                        </div>
                      </div>
                      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="w-16 h-16 bg-gray-900/90 backdrop-blur-sm rounded-full flex items-center justify-center border border-gray-700/50 shadow-lg">
                          <i className="ri-play-fill text-white text-2xl ml-1"></i>
                        </div>
                      </div>
                      <div className="absolute top-4 left-4">
                        <div className="bg-black/70 backdrop-blur-sm rounded-full px-3 py-1 text-white text-sm font-medium">
                          {content.platform}
                        </div>
                      </div>
                      <div className="absolute top-4 right-4">
                        <div className="bg-purple-600/90 backdrop-blur-sm rounded-full px-3 py-1 text-white text-sm font-medium">
                          {content.type}
                        </div>
                      </div>
                    </div>
                    <div className="mt-4 text-center">
                      <h3 className="text-lg font-semibold text-gray-900 mb-1 leading-tight">{content.title}</h3>
                      <p className="text-gray-600 text-base">{content.client}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Second Row: 4 Vertical Videos */}
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
                {portfolioContent.filter(content => content.format === 'short').map((content) => (
                  <div key={content.id} className="group cursor-pointer">
                    <div 
                      className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                      onClick={() => handleContentClick(content)}
                      style={{ aspectRatio: '9/16' }}
                    >
                      <img 
                        src={content.thumbnail}
                        alt={content.title}
                        className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                          <h3 className="text-base font-bold mb-2 leading-tight">{content.title}</h3>
                          <p className="text-purple-200 flex items-center text-sm">
                            <i className="ri-building-line mr-2"></i>
                            {content.client}
                          </p>
                          <p className="text-pink-200 text-xs">{content.engagement}</p>
                        </div>
                      </div>
                      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="w-12 h-12 bg-gray-900/90 backdrop-blur-sm rounded-full flex items-center justify-center border border-gray-700/50 shadow-lg">
                          <i className="ri-play-fill text-white text-lg ml-1"></i>
                        </div>
                      </div>
                      <div className="absolute top-4 left-4">
                        <div className="bg-black/70 backdrop-blur-sm rounded-full px-3 py-1 text-white text-xs font-medium">
                          {content.platform}
                        </div>
                      </div>
                      <div className="absolute top-4 right-4">
                        <div className="bg-purple-600/90 backdrop-blur-sm rounded-full px-3 py-1 text-white text-xs font-medium">
                          {content.type}
                        </div>
                      </div>
                    </div>
                    <div className="mt-4 text-center">
                      <h3 className="text-base font-semibold text-gray-900 mb-1 leading-tight">{content.title}</h3>
                      <p className="text-gray-600 text-sm">{content.client}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="text-center mt-16">
            <Link 
              to="/contact" 
              className="inline-block px-10 py-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold text-lg rounded-full hover:from-purple-700 hover:to-pink-700 transition-all duration-300 transform hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap"
            >
              START YOUR CAMPAIGN
            </Link>
          </div>
        </div>
      </section>

      {/* Content Modal */}
      {selectedContent && (
        <div className="fixed inset-0 bg-black/95 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="relative w-full max-w-6xl mx-auto">
            {/* Close Button - Top Right (Desktop) */}
            <button
              onClick={closeContentModal}
              className="absolute -top-12 right-0 text-white hover:text-gray-300 cursor-pointer transition-colors z-10 hidden md:block"
            >
              <i className="ri-close-line text-3xl"></i>
            </button>

            {/* Close Button - Inside Modal (Mobile-friendly) */}
            <button
              onClick={closeContentModal}
              className="absolute top-4 right-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white rounded-full p-2 cursor-pointer transition-all z-20"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
            
            <div className="relative bg-black rounded-2xl overflow-hidden shadow-2xl">
              {selectedContent.format === 'short' || selectedContent.type === 'Reel' || selectedContent.type === 'Short Video' || selectedContent.type === 'Story' ? (
                // Vertical video display for social media short content
                <div className="flex justify-center bg-black">
                  <div className="relative" style={{ width: '360px', height: '640px' }}>
                    <iframe
                      src={`https://www.youtube.com/embed/${selectedContent.videoId}?autoplay=1&rel=0&modestbranding=1&vq=hd1440`}
                      title={selectedContent.title}
                      className="w-full h-full border-0"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              ) : (
                // Horizontal video display for regular content
                <div className="aspect-video">
                  <iframe
                    src={`https://www.youtube.com/embed/${selectedContent.videoId}?autoplay=1&rel=0&modestbranding=1&vq=hd1440`}
                    title={selectedContent.title}
                    className="w-full h-full"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              )}
              
              <div className="p-6 bg-gradient-to-r from-gray-900 to-black text-white">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-2xl font-bold mb-2">{selectedContent.title}</h3>
                    <p className="text-gray-300 flex items-center mb-2">
                      <i className="ri-building-line mr-2"></i>
                      {selectedContent.client}
                    </p>
                    <p className="text-gray-400 text-sm">{selectedContent.description}</p>
                  </div>
                  <div className="text-right">
                    <span className="inline-block px-4 py-2 bg-purple-600 text-white rounded-full text-sm font-medium mb-2">
                      {selectedContent.platform}
                    </span>
                    <div className="text-gray-300 text-sm">{selectedContent.type}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Services Section */}
      <section id="services" className="py-32 bg-gradient-to-br from-gray-50 to-purple-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-20">
            <span className="inline-block px-8 py-3 bg-purple-100 rounded-full text-purple-700 font-semibold text-sm tracking-wider border border-purple-200 mb-6">
              OUR SERVICES
            </span>
            <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-8 tracking-tight">
              Social Media Services
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-16">
              Professional social media content services designed to grow your online presence and engage your audience
            </p>
            
            {/* Single Call-to-Action Button */}
            <div className="mt-12">
              <Link
                to="/contact"
                className="inline-block py-6 px-16 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-2xl font-bold text-2xl transition-all duration-300 hover:from-purple-700 hover:to-pink-700 shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer"
              >
                Let's Discuss Your Project & Get a Quote Now
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            {/* Company Info */}
            <div className="md:col-span-1">
              <div className="flex items-center space-x-3 mb-4">
                <img 
                  src="https://images.squarespace-cdn.com/content/v1/6329980709c417765c18ef9c/1663928993488-9PHELX1GHR1MGT4SNOLP/minchio+brothers+logo.png?format=100w" 
                  alt="Minchio Brothers Logo" 
                  className="h-10 w-10"
                />
                <span className="text-gray-900 font-bold text-lg">MINCHIO BROTHERS</span>
              </div>
              <p className="text-gray-600 mb-4 text-sm leading-relaxed">
                Professional videography services across Queensland, specializing in Real Estate, Commercial, and Social Media content.
              </p>
              <div className="flex space-x-3">
                <a href="https://www.instagram.com/minchiobrothers/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer">
                  <i className="ri-instagram-fill text-white text-lg"></i>
                </a>
                <a href="mailto:media@matthewminchio.com" className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer">
                  <i className="ri-mail-fill text-white text-lg"></i>
                </a>
                <a href="tel:+61431323137" className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors cursor-pointer">
                  <i className="ri-phone-fill text-white text-lg"></i>
                </a>
              </div>
            </div>

            {/* Services */}
            <div>
              <h3 className="text-gray-900 font-bold mb-4">Services</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/real-estate" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Real Estate Videography</Link></li>
                <li><Link to="/commercial" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Commercial Production</Link></li>
                <li><Link to="/social-media" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Social Media Content</Link></li>
                <li><span className="text-gray-600">Drone Videography</span></li>
                <li><span className="text-gray-600">Event Coverage</span></li>
                <li><span className="text-gray-600">Brand Storytelling</span></li>
              </ul>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-gray-900 font-bold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-sm">
                <li><Link to="/" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Home</Link></li>
                <li><Link to="/reviews" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Client Reviews</Link></li>
                <li><Link to="/contact" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Contact Us</Link></li>
                <li><Link to="/contact" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Get Quote</Link></li>
                <li><a href="https://www.minchsolutions.au" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">Minch Solutions</a></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-gray-900 font-bold mb-4">Contact Info</h3>
              <div className="space-y-3 text-sm">
                <div className="flex items-start space-x-2">
                  <i className="ri-phone-line text-gray-600 mt-0.5"></i>
                  <div>
                    <a href="tel:+61431323137" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer font-medium">+61 431 323 137</a>
                    <p className="text-gray-500 text-xs">Available 9AM - 6PM</p>
                  </div>
                </div>
                <div className="flex items-start space-x-2">
                  <i className="ri-mail-line text-gray-600 mt-0.5"></i>
                  <div>
                    <a href="mailto:media@matthewminchio.com" className="text-gray-600 hover:text-gray-900 transition-colors cursor-pointer font-medium">media@matthewminchio.com</a>
                    <p className="text-gray-500 text-xs">24hr response time</p>
                  </div>
                </div>
                <div className="flex items-start space-x-2">
                  <i className="ri-map-pin-line text-gray-600 mt-0.5"></i>
                  <div>
                    <p className="text-gray-600 font-medium">Service Areas:</p>
                    <p className="text-gray-500 text-xs">Townsville, Brisbane, Gold Coast</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-200 pt-6 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm mb-4 md:mb-0">© 2021 MINCHIO BROTHERS. ALL RIGHTS RESERVED</p>
            <div className="flex items-center space-x-4 text-sm">
              <a href="https://www.minchsolutions.au" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-600 cursor-pointer">
                Made by Minchsolutions
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
